const STORAGE_KEY = "order_sheet_viewed_estimate_ids_v1";

/**
 * 確認用注文書を開いた見積提案を、タブ単位で覚えておくための保存領域。
 *
 * iOS Safari は Blob の download 属性を無視してPDFを同じタブで開くため、注文書を開いた
 * 時点でアプリから離脱する。React の state だけで確認済みを持っていると戻ったときに失われ、
 * 同意チェックが押せないまま発注できなくなる。離脱をまたいで残る場所に置く。
 *
 * sessionStorage 自体が例外を投げる環境（プライベートモード等）があるため、読み書きの失敗は
 * 握りつぶして「未確認」として扱う。確認済みが失われても、注文書を開き直せば発注できる。
 */
const readAll = (): string[] => {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((estimateId): estimateId is string => typeof estimateId === "string");
  } catch {
    return [];
  }
};

/**
 * 確認用注文書を開いた見積提案のIDを返す。
 *
 * @returns 開いた見積提案のID一覧。取得できない場合は空配列
 * @example
 * readViewedOrderSheetEstimateIds(); // => ["a0cA2000002aRBpIAM"]
 */
export const readViewedOrderSheetEstimateIds = (): string[] => readAll();

/**
 * 確認用注文書を開いたことを記録する。
 *
 * @param estimateId 対象の見積提案ID
 * @example
 * markOrderSheetViewed("a0cA2000002aRBpIAM");
 */
export const markOrderSheetViewed = (estimateId: string): void => {
  if (typeof window === "undefined") return;
  const all = readAll();
  if (all.includes(estimateId)) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...all, estimateId]));
  } catch {
    // 保存できない環境では確認済みを引き継げないが、発注導線自体は塞がない
  }
};
